import { inject, PLATFORM_ID } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptorFn,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { throwError, EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

export const tokenInterceptorFn: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);

  let token = '';

  // ✅ Public APIs that should not require a token
  const publicUrls = [
    '/master_district',
    '/master_block',
    '/master_village',
    // 'foc_get_block',
    // '/get_village',
    '/register',
    '/check_login',
    '/login',
    '/verify_otp',
    '/resend_otp',
    // test-push endpoint has no auth on the backend; without this entry the
    // interceptor silently drops the request (return EMPTY) when logged out,
    // making the Send Test Notification button look dead
    '/notification/send',
    // Kuruvai Special Package registration is public (like the govt portal's)
    '/kuruvai_',
    '/get_grainsdata',
    '/agri_entrepreneur_register',
    // Fertiliser stock/price/bio lookups — routes/productservice.js mounts these
    // with NO verifyToken, so the backend already treats them as public; without
    // these entries the interceptor silently drops them (EMPTY) for a logged-out
    // user and the dropdowns just come up blank
    '/get_fsp_',
    '/get_bio_fertilizer',
  ]; // add more if needed

  const isPublic = publicUrls.some((url) => req.url.includes(url));

  // ✅ If it's a public API → skip adding token
  if (isPublic) {
    return next(req);
  }

  // ✅ Get token from localStorage (browser only)
  if (isPlatformBrowser(platformId)) {
    token = localStorage.getItem('authToken') || '';
  }

  // ✅ If no token → clear storage + redirect
  if (!token) {
    if (isPlatformBrowser(platformId)) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
    }
    router.navigate(['/login']);
    return EMPTY; // stop the request
  }

  // ✅ Attach token to all requests except public APIs
  req = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(req).pipe(
    tap(
      (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // optional: handle success
        }
      },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 || err.status === 403) {
            if (isPlatformBrowser(platformId)) {
              localStorage.removeItem('authToken');
              localStorage.removeItem('user');
            }
            router.navigate(['/login']);
          }
        }
      }
    ),
    catchError((error: HttpErrorResponse) => {
      return throwError(() => error);
    })
  );
};
